"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KnockNotificationButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _KnockTypes = require("../../../../constants/KnockTypes");
var _ = require("../../..");
var _KnockNotificationButton = require("./KnockNotificationButton.styled");
var _Knocks = require("../../Knocks");
var _hooks = require("../../../../hooks");
var _KnockNotificationItemList = require("../KnockNotificationItemList");
var _useTranslate2 = require("../../../../locales/useTranslate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var voidy = function voidy() {};
var EMPTY_LIST = [];
var KnockNotificationButton = exports.KnockNotificationButton = _react["default"].memo(function (_ref) {
  var knocks = _ref.knocks,
    onApproveAll = _ref.onApproveAll,
    updateKnockRequest = _ref.updateKnockRequest,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    _ref$unassignedCamera = _ref.unassignedCameraPresenters,
    unassignedCameraPresenters = _ref$unassignedCamera === void 0 ? EMPTY_LIST : _ref$unassignedCamera,
    _ref$unassignedScreen = _ref.unassignedScreenSharePresenters,
    unassignedScreenSharePresenters = _ref$unassignedScreen === void 0 ? EMPTY_LIST : _ref$unassignedScreen,
    _ref$assignedScreenSh = _ref.assignedScreenSharePresenters,
    assignedScreenSharePresenters = _ref$assignedScreenSh === void 0 ? EMPTY_LIST : _ref$assignedScreenSh,
    _ref$onAVClicked = _ref.onAVClicked,
    onAVClicked = _ref$onAVClicked === void 0 ? voidy : _ref$onAVClicked,
    liveCameras = _ref.liveCameras,
    showNotificationList = _ref.showNotificationList,
    onToggleNotification = _ref.onToggleNotification,
    _ref$onAssignKnockToS = _ref.onAssignKnockToSource,
    onAssignKnockToSource = _ref$onAssignKnockToS === void 0 ? voidy : _ref$onAssignKnockToS,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    isProgramStarted = _ref.isProgramStarted,
    displayTooltip = _ref.displayTooltip,
    _ref$toolTipFade = _ref.toolTipFade,
    toolTipFade = _ref$toolTipFade === void 0 ? false : _ref$toolTipFade,
    _ref$toolTipPlacement = _ref.toolTipPlacement,
    toolTipPlacement = _ref$toolTipPlacement === void 0 ? 'bottom' : _ref$toolTipPlacement;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isKnockListOpen = _useState2[0],
    setIsKnockListOpen = _useState2[1];
  var hasCount = knocks.length > 0;
  var canShowNotificationList = hasCount && showNotificationList && isProgramStarted && !isKnockListOpen;
  var toggleKnockList = (0, _react.useCallback)(function () {
    onToggleNotification(false);
    setIsKnockListOpen(!isKnockListOpen);
  }, [onToggleNotification, isKnockListOpen]);
  var handleUpdateKnock = (0, _react.useCallback)(function (knock, changes) {
    if (knocks.length === 1) {
      setIsKnockListOpen(false);
    }
    updateKnockRequest(knock, changes);
  }, [knocks.length, updateKnockRequest]);
  var handleNotificationItemList = (0, _react.useCallback)(function (e) {
    e.persist();
    var isTagName = e.target.tagName === 'BUTTON';
    var isParentNode = e.target.parentNode.tagName === 'BUTTON';
    var isClosestButton = e.target.closest('BUTTON');
    if (!isTagName && !isParentNode && !isClosestButton) {
      toggleKnockList();
    }
  }, [toggleKnockList]);
  var getItemDisabledState = (0, _react.useCallback)(function (knock) {
    var isScreenShare = knock.type === _KnockTypes.SCREENSHARE;
    if (isScreenShare && assignedScreenSharePresenters.length >= 2) {
      return true;
    }
    return false;
  }, [assignedScreenSharePresenters.length]);
  var handleAssignKnockToSource = (0, _react.useCallback)(function (knock) {
    return function (sourceId) {
      if (knock.sourceId !== sourceId) {
        onAssignKnockToSource(_objectSpread(_objectSpread({}, knock), {}, {
          sourceId: sourceId
        }));
      }
    };
  }, [onAssignKnockToSource]);
  var onApprove = (0, _react.useCallback)(function (knock) {
    return handleUpdateKnock(knock, {
      status: _KnockTypes.ACCEPTED
    });
  }, [handleUpdateKnock]);
  var onDeny = (0, _react.useCallback)(function (knock) {
    return handleUpdateKnock(knock, {
      status: _KnockTypes.DENIED
    });
  }, [handleUpdateKnock]);
  var commonProps = (0, _react.useMemo)(function () {
    return {
      knocks: knocks,
      targetElementId: 'KnockNotificationButton',
      onApproveAll: onApproveAll,
      unassignedCameraPresenters: unassignedCameraPresenters,
      unassignedScreenSharePresenters: unassignedScreenSharePresenters,
      maxCamerasExceeded: maxCamerasExceeded,
      onAVClicked: onAVClicked,
      liveCameras: liveCameras,
      onAssignKnockToSource: handleAssignKnockToSource,
      onApprove: onApprove,
      onDeny: onDeny,
      getItemDisabledState: getItemDisabledState
    };
  }, [knocks, onApproveAll, unassignedCameraPresenters, unassignedScreenSharePresenters, maxCamerasExceeded, onAVClicked, liveCameras, handleAssignKnockToSource, onApprove, onDeny, getItemDisabledState]);
  var closePopover = (0, _react.useCallback)(function (e) {
    var notificationButton = document.getElementById('KnockNotificationButton');
    var popOverEl = document.getElementById('knock-list-popover');
    if (notificationButton && (notificationButton.isSameNode(e.target) || notificationButton.contains(e.target))) {
      return;
    }
    if (popOverEl && !popOverEl.isSameNode(e.target) && !popOverEl.contains(e.target)) {
      toggleKnockList();
    }
  }, [toggleKnockList]);

  //Watch opened popover so it could be closed when mouse is down outside of it.
  (0, _hooks.useHideKnockList)(isKnockListOpen, closePopover);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_KnockNotificationButton.NotificationButtonWrapper, {
    $isStudioLite: isStudioLite,
    $hasCount: hasCount,
    id: "KnockNotificationButton",
    onClick: toggleKnockList,
    "data-testid": "notification-button",
    "data-dd-action-name": "Presenter Knock Requests - ".concat(knocks.length, " knocks available")
  }, _react["default"].createElement(_KnockNotificationButton.NotificationIconWrapper, null, _react["default"].createElement(_KnockNotificationButton.StyledNotificationButton, {
    $isStudioLite: isStudioLite,
    $hasCount: hasCount,
    icon: hasCount || isStudioLite ? _freeSolidSvgIcons.faBell : _freeRegularSvgIcons.faBell
  })), hasCount && _react["default"].createElement(_KnockNotificationButton.NotificationCountWrapper, {
    $isStudioLite: isStudioLite
  }, _react["default"].createElement(_KnockNotificationButton.NotificationCountText, null, knocks.length)), _react["default"].createElement(_.ToolTip, {
    targetElement: "KnockNotificationButton",
    message: translate('KnockNotificationButton_Popover'),
    mode: "dark",
    fade: toolTipFade,
    placement: toolTipPlacement,
    displayTooltip: displayTooltip
  })), canShowNotificationList && _react["default"].createElement("div", {
    onClick: handleNotificationItemList,
    "data-testid": "notification-item-list",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, _react["default"].createElement(_KnockNotificationItemList.KnockNotificationItemList, (0, _extends2["default"])({
    isPopoverOpen: canShowNotificationList
  }, commonProps))), _react["default"].createElement(_Knocks.KnockList, (0, _extends2["default"])({
    onTogglePopover: toggleKnockList,
    isPopoverOpen: isKnockListOpen
  }, commonProps)));
});
KnockNotificationButton.propTypes = {
  knocks: _propTypes.array,
  onAVClicked: _propTypes.func,
  toolTipFade: _propTypes.bool,
  onApproveAll: _propTypes.func,
  liveCameras: _propTypes.number,
  displayTooltip: _propTypes.bool,
  isProgramStarted: _propTypes.bool,
  maxCamerasExceeded: _propTypes.bool,
  updateKnockRequest: _propTypes.func,
  toolTipPlacement: _propTypes.string,
  showNotificationList: _propTypes.bool,
  onToggleNotification: _propTypes.func,
  onAssignKnockToSource: _propTypes.func,
  onMouseEnter: _propTypes.func.isRequired,
  onMouseLeave: _propTypes.func.isRequired,
  unassignedCameraPresenters: _propTypes.array,
  assignedScreenSharePresenters: _propTypes.array,
  unassignedScreenSharePresenters: _propTypes.array
};